import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import horseIcon from '../../assets/images/svgs/horse.svg';
import GreyhoundIcon from '../../assets/images/svgs/greyhound.svg';
import { setCloseComingSoonModal } from '../../store/modals/comingSoonModal.slice';


const imgTypeArr = [
  { type: 'Horse Racing', img: horseIcon},
  { type: 'Greyhound Racing', img: GreyhoundIcon},
]

const ComingSoonPopup = () => {
  const dispatch = useDispatch();
  const open = useSelector((state) => state.comingSoonModal.isOpen);
  const type = useSelector((state) => state.comingSoonModal.type);
  

  return (
    <>
      {open&& 
        <div className=" absolute top-0 left-0 bottom-0 right-0 h-full w-full z-30 bg-bg_PopUpParentBg flex items-center justify-center font-lato">
          <div className="popUpBoxShadow relative origin-center popUpOpenAnimation bg-bg_Quaternary w-[86%] py-3 px-2 rounded max-w-[360px]">
            
            <div 
              className='w-[100%] max-w-[360px] absolute -translate-x-2/4 -translate-y-2/4 flex flex-col justify-between px-2 py-3 rounded-[10px] left-2/4 top-2/4'
              style={{background: '#fff'}}
            >
              <div className='w-full h-full flex flex-col items-center'>
                <img 
                  src={imgTypeArr.find(item => item.type == type)['img']} 
                  style={{width: 100, height: 100}} 
                  alt={'upcomging-game'}
                />
                <div className='text-black text-[22px] not-italic font-bold leading-[normal] mt-[15px]' >
                  Coming Soon!
                </div>
                <div className='text-[#8B8B8B] text-sm not-italic font-semibold leading-[120%] my-[13px]'>
                  {type} Will Be Available Soon
                </div>
              </div>

              <div className='flex justify-center'>
                <div 
                  className='flex justify-center items-center h-11 w-[90%] text-white text-center text-base not-italic font-bold leading-[14px] tracking-[0.84px] capitalize rounded-sm cursor-pointer bg-bg_Primary'
                  onClick={() => { dispatch(setCloseComingSoonModal()); }}
                >
                  Close
                </div>
              </div>
            </div>

          </div>
        </div>
      }
    </>
  )
}

export default ComingSoonPopup;
